const S3_CONFIG = {
  bucket: process.env.REACT_APP_FINGERPRINT_BUCKET_NAME,
  consentBucket: process.env.REACT_APP_CONSENT_BUCKET_NAME,
};

export default S3_CONFIG;
